// Minimal CSV parser — handles quoted fields, escaped quotes ("") and CRLF.
// Good enough for employee roster uploads without pulling in a dependency.

export interface ParsedCsv {
  headers: string[];
  rows: Record<string, string>[];
}

export function parseCSV(text: string): ParsedCsv {
  // Strip a UTF-8 BOM if present.
  const input = text.replace(/^﻿/, '');
  const records: string[][] = [];
  let field = '';
  let record: string[] = [];
  let inQuotes = false;

  for (let i = 0; i < input.length; i++) {
    const ch = input[i];

    if (inQuotes) {
      if (ch === '"') {
        if (input[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += ch;
      }
      continue;
    }

    if (ch === '"') {
      inQuotes = true;
    } else if (ch === ',') {
      record.push(field);
      field = '';
    } else if (ch === '\n' || ch === '\r') {
      // End of record on \n; swallow \r\n pairs.
      if (ch === '\r' && input[i + 1] === '\n') i++;
      record.push(field);
      field = '';
      // Skip fully-empty lines.
      if (record.length > 1 || record[0] !== '') records.push(record);
      record = [];
    } else {
      field += ch;
    }
  }
  // Flush the last field/record (file may not end with a newline).
  if (field !== '' || record.length > 0) {
    record.push(field);
    if (record.length > 1 || record[0] !== '') records.push(record);
  }

  if (records.length === 0) return { headers: [], rows: [] };

  const headers = records[0].map((h) => h.trim());
  const rows: Record<string, string>[] = [];
  for (let r = 1; r < records.length; r++) {
    const row: Record<string, string> = {};
    headers.forEach((h, idx) => {
      row[h] = (records[r][idx] ?? '').trim();
    });
    rows.push(row);
  }
  return { headers, rows };
}
